<mat-stepper [orientation]="(stepperOrientation | async)!">
    <ng-template matStepperIcon="edit" let-index="index">
        {{ index + 1 }}
    </ng-template>

    <mat-step name="1-SelectTipology" *ngIf="!this.magowebService.subscriptionNfs">
        <div class="containerStepper">
            <ng-template matStepLabel>
                <span translate>COMMONS.SELECT_TYPOLOGY</span><br />
                <span style="font-size: 0.8rem">({{ this.magowebService.isSFT ? 'SFT' : 'SAAS' }})</span>
            </ng-template>
            <h4>{{ typology_intro }}</h4>
            <br />
            <div style="display: flex; justify-content: center">
                <mat-card
                    [ngClass]="
                        this.magowebService.isSFT
                            ? 'fuse-card-medium text-center card-selected-green style-3 mat-elevation-z15 '
                            : 'fuse-card-medium text-center style-3 mat-elevation-z4'
                    "
                >
                    <mat-card-title
                        ><span>{{ sft_title }}</span></mat-card-title
                    >
                    <mat-card-content>{{ sft_description }}</mat-card-content>
                    <mat-card-actions>
                        <button
                            mat-flat-button
                            color="primary"
                            [disabled]="this.magowebService.isModifyStatus"
                            class="buttonEditionChoice"
                            (click)="onClickType('sft')"
                        >
                            <span translate>INDUSTRY_CONFIGURATOR.SELECT</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
                <mat-card
                    fxlayout="column"
                    [ngClass]="
                        !this.magowebService.isSFT
                            ? 'fuse-card-medium text-center card-selected-green style-3 mat-elevation-z15 '
                            : 'fuse-card-medium text-center style-3 mat-elevation-z4'
                    "
                >
                    <mat-card-title
                        ><span>{{ saas_title }}</span></mat-card-title
                    >
                    <mat-card-content>{{ saas_description }}</mat-card-content>
                    <mat-card-actions>
                        <button
                            mat-flat-button
                            color="primary"
                            class="buttonEditionChoice"
                            [disabled]="this.magowebService.isModifyStatus"
                            (click)="onClickType('saas')"
                        >
                            <span translate>INDUSTRY_CONFIGURATOR.SELECT</span>
                        </button>
                    </mat-card-actions>
                </mat-card>
            </div>
            <mat-radio-group class="radio-group" (change)="typeSelectionChange($event)" name="typeOptionSelection" *ngIf="false">
                <mat-radio-button
                    class="radio-button"
                    value="sft"
                    [checked]="this.magowebService.isSFT"
                    #sft
                    [disabled]="this.magowebService.isModifyStatus"
                >
                    <span translate class="text-bold">SFT</span>
                </mat-radio-button>
                <mat-radio-button class="radio-button" value="saas" #saas [disabled]="this.magowebService.isModifyStatus">
                    <span translate class="text-bold">SAAS</span>
                </mat-radio-button>
            </mat-radio-group>
            <div class="text-center">
                <button mat-stroked-button color="secondary" [disabled]="setTipologyDisabled()" matStepperNext>
                    {{ this.nextString }}
                </button>
            </div>
            <div *ngIf="!this.functLoaded">
                <tb-loading></tb-loading>
            </div>
        </div>
    </mat-step>

    <mat-step name="2-SelectCountry">
        <div class="containerStepper">
            <ng-template matStepLabel>
                <span translate>INDUSTRY.CHOOSE_COUNTRY</span><br />
                <span
                    *ngIf="this.magowebService?.countryValue != 'none' && this.magowebService?.countryValue != ''"
                    style="font-size: 0.8rem"
                    >({{ this.magowebService?.countryDescri }})</span
                >
            </ng-template>
            <ms-country-selection
                (countrySelectedDescri)="selectedDescri($event)"
                (countrySelectedValue)="selectedValue($event)"
                [isModifyStatus]="this.magowebService?.isModifyStatus && !this.storeRoleService.IsInternal"
                [isMagoWeb]="true"
            ></ms-country-selection>
            <ms-instances-selection
                *ngIf="this.storeRoleService.IsInternal"
                (instanceSelectedDescri)="selectedInstanceDescri($event)"
                (instanceSelectedValue)="selectedInstanceValue($event)"
            ></ms-instances-selection>

            <div class="text-center">
                <button mat-stroked-button color="secondary" matStepperPrevious *ngIf="!this.magowebService.subscriptionNfs">
                    {{ this.backString }}
                </button>
                <button mat-stroked-button color="secondary" [disabled]="setCountryDisabled()" matStepperNext>
                    {{ this.nextString }}
                </button>
            </div>
            <div *ngIf="!this.functLoaded">
                <tb-loading></tb-loading>
            </div>
        </div>
    </mat-step>

    <mat-step name="3-SelectUsers">
        <div class="containerStepper">
            <ng-template matStepLabel>
                <span translate>MAGOWEB_CONFIGURATION.CHOOSEN_PACK</span><br />
                (<span
                    *ngIf="this.magowebService?.currentIndustry != 'none' || this.magowebService?.currentIndustry?.TranslatedName != ''"
                    style="font-size: 0.8rem"
                    >{{ this.magowebService?.currentIndustry?.TranslatedName }}</span
                >)
            </ng-template>
            <div *ngIf="this.magowebService?.functionalitygroupsAlwaysAvalilable.length == 0">
                <tb-loading></tb-loading>
            </div>
            <div *ngIf="this.magowebService?.functionalitygroupsAlwaysAvalilable.length > 0">
                <div *ngIf="this.magowebService?.functionalitygroupsAlwaysAvalilable.length > 0">
                    <ms-functionality-included
                        [functionalitygroups]="this.magowebService?.functionalitygroupsAlwaysAvalilable"
                        [editionSelected]="this.magowebService?.edition"
                        [currentIndustry]="this.magowebService?.currentIndustry"
                        [currIndustryPurchInfo]="this.magowebService?.currIndustryPurchInfo"
                        [moduleCode]="this.magowebService?.moduleCode"
                        [version]="this.magowebService?.version"
                        [countrySelected]="this.magowebService?.countryValue"
                        [parent]="this.magowebService?.moduleCode"
                    ></ms-functionality-included>
                </div>
                <div style="text-align: center">
                    <button mat-stroked-button color="secondary" matStepperPrevious>
                        {{ this.backString }}
                    </button>
                    <button mat-stroked-button color="secondary" matStepperNext>
                        {{ this.nextString }}
                    </button>
                </div>
            </div>
        </div>
    </mat-step>

    <mat-step name="4-SelectFunctions">
        <div class="containerStepper">
            <ng-template matStepLabel> <span translate>MAGOWEB_CONFIGURATION.OPTIONAL_MODULES</span><br /> </ng-template>
            <div *ngIf="this.functLoaded">
                <ms-functionalities-selection
                    [functionalitygroups]="this.magowebService?.functionalitygroupsNoCAL"
                    [editionSelected]="this.magowebService?.edition"
                    [currentIndustry]="this.magowebService?.currentIndustry"
                    [currIndustryPurchInfo]="this.magowebService?.currIndustryPurchInfo"
                    [moduleCode]="this.magowebService?.moduleCode"
                    [version]="this.magowebService?.version"
                    [countrySelected]="this.magowebService?.countryValue"
                    [parent]="this.magowebService?.moduleCode"
                ></ms-functionalities-selection>
            </div>
            <div class="text-center">
                <button mat-stroked-button color="secondary" matStepperPrevious>
                    {{ this.backString }}
                </button>
                <button mat-stroked-button color="secondary" (click)="enableButton()" [disabled]="setCountryDisabled()" matStepperNext>
                    {{ this.nextString }}
                </button>
            </div>
        </div>
        <div *ngIf="!this.functLoaded">
            <tb-loading></tb-loading>
        </div>
    </mat-step>

    <mat-step name="5-SelectFunctions">
        <div class="containerStepper">
            <ng-template matStepLabel> <span translate>MAGOWEB_CONFIGURATION.CAL_MODULES</span><br /> </ng-template>
            <div>
                <h3 translate>MAGOWEB_CONFIGURATION.INTRO_CAL_SELECTION</h3>
            </div>
            <div *ngIf="this.functLoaded">
                <ms-cal-selection
                    [CALFeature]="this.magowebService?.CALFeature"
                    [productID]="this.magowebService?.productID"
                    (featureClicked)="updateConfiguration()"
                ></ms-cal-selection>
            </div>
            <div class="text-center">
                <button mat-stroked-button color="secondary" matStepperPrevious>
                    {{ this.backString }}
                </button>
                <button mat-stroked-button color="secondary" matStepperNext *ngIf="this.magowebService.subscriptionNfs">
                    {{ this.nextString }}
                </button>
            </div>
        </div>
        <div *ngIf="!this.functLoaded">
            <tb-loading></tb-loading>
        </div>
    </mat-step>

    <mat-step name="6-SelectFunctions_horizontal" [completed]="!privacyNotSelected" *ngIf="false">
        <div class="containerStepper" style="width: 86%">
            <ng-template matStepLabel>
                <span translate> COMMONS.PRIVACY_AGREEMENT </span>
            </ng-template>
            <ms-privacy-agreement></ms-privacy-agreement>
        </div>
        <div class="text-center">
            <button mat-stroked-button color="secondary" matStepperPrevious>
                {{ this.backString }}
            </button>
        </div>
    </mat-step>
</mat-stepper>
